import { BiSolidUserAccount } from "solid-icons/bi";
import { type Component, For, Show } from "solid-js";
import { useI18n } from "@/api/i18n";
import { AvatarToDeprecate } from "@/components/ui/avatar";
import {
  MAX_SELECTION,
  useFreelanceSearchStore,
} from "../store/freelance-search-store";

export const FreelancerSelectionSummaryBar: Component = () => {
  const { t } = useI18n();
  const [store, setStore] = useFreelanceSearchStore();

  const selected = () => store.selectedFreelancers;
  const remaining = () => MAX_SELECTION - selected().length;

  const clearSelection = () => {
    setStore("selectedFreelancers", []);
  };

  return (
    <div class="flex items-center justify-between gap-4 p-4 border border-gray-200 rounded-lg bg-white shadow-sm">
      <div class="flex items-center gap-3">
        <div class="flex -space-x-2">
          <For each={selected().slice(0, 3)}>
            {(freelancer) => (
              <AvatarToDeprecate
                src={freelancer.avatar_url}
                alt={freelancer.full_name}
                class="h-8 w-8 border-2 border-white"
                fallback={<BiSolidUserAccount class="w-4 h-4" />}
              />
            )}
          </For>
          <Show when={selected().length > 3}>
            <div class="h-8 w-8 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center text-xs font-medium text-gray-600">
              +{selected().length - 3}
            </div>
          </Show>
        </div>
        <p class="text-sm text-gray-700">
          {selected().length === 1
            ? t("company.search.freelancers.result.selection_bar.selected_one")
            : t(
                "company.search.freelancers.result.selection_bar.selected_other",
                { count: selected().length },
              )}{" "}
          ·{" "}
          {t("company.search.freelancers.result.selection_bar.remaining", {
            count: remaining(),
          })}
        </p>
      </div>
      <button
        type="button"
        class="text-sm text-gray-500 hover:text-gray-700 shrink-0"
        onClick={clearSelection}
      >
        × {t("company.search.freelancers.result.selection_bar.cancel")}
      </button>
    </div>
  );
};
